export enum variants {
    common = 'common',
    footer = 'footer',
    sidebar = 'sidebar',
}
